import React, { useState } from "react";
import { useGlobal } from "reactn";
import styled from "styled-components";
import Checkbox from "../../components/Checkbox";
import AddSongwriterModal from "../create/AddSongwriterModal";
import { filterShare } from "../create/CreateComposition";
import axios from "axios";
import apiRoot from "../../apiRoot";

const InputGroup = styled.div`
  flex: 1;
  ${(props) =>
    !props.altTitle &&
    `@media screen and (max-width: 600px) {
    width: 100%;
  }`}
`;

const Label = styled.label`
  font-weight: 500;
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
`;

const Input = styled.input`
  background: transparent;
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 2px;
  width: calc(100% - 24px);
  padding: 6px 10px;
  outline: none;
  height: 36px;
  box-sizing: border-box;
  -webkit-appearance: none;
  transition: border-color 0.2s;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
  display: block;
  :focus {
    border-color: rgba(255, 255, 255, 0.3);
  }
  ::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  margin-top: 20px;
  @media screen and (max-width: 600px) {
    flex-direction: column;
  }
`;

const Button = styled.button`
  padding: 6px 20px;
  background: linear-gradient(135deg, hsl(160, 95%, 35%), hsl(220, 92%, 45%));
  color: white;
  font-weight: 600;
  outline: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: pointer;
  text-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  transition: filter 0.2s;
  :hover {
    filter: brightness(110%);
  }
  svg {
    margin-left: 5px;
  }
`;

const LightButton = styled(Button)`
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.8);
  transition: background 0.2s;
  margin-right: 20px;
  :hover {
    background: rgba(255, 255, 255, 0.14);
  }
  svg {
    margin-right: 5px;
    margin-left: -5px;
  }
`;

const VerticalDivider = styled.div`
  margin-bottom: 10px;
`;

const WriterContainer = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: 1fr 1fr 1fr;
  max-width: 100%;
  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }
  @media screen and (max-width: 800px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media screen and (max-width: 670px) {
    grid-template-columns: 1fr 1fr;
  }
  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const Songwriter = styled.div`
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  background: rgba(255, 255, 255, 0.1);
  min-width: 180px;
  box-sizing: border-box;
  flex: 1;
  @media screen and (max-width: 600px) {
    width: 100%;
    max-width: 100%;
    margin-right: 0;
  }
`;

const WriterName = styled.h4`
  color: white;
  margin: 0;
`;

const WriterSociety = styled.h5`
  font-weight: 500;
  color: rgba(255, 255, 255, 0.5);
  margin-top: 5px;
  margin-bottom: 10px;
  font-size: 12px;
`;

const You = styled.span`
  margin-left: 10px;
  background: rgba(255, 255, 255, 0.1);
  padding: 2px 10px;
  border-radius: 10px;
  letter-spacing: 0.5px;
  font-weight: 500;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
`;

const RemoveButton = styled.div`
  cursor: pointer;
  text-align: center;
  width: 100%;
  margin-top: 5px;
  padding: 10px 0 0 0;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 500;
  transition: color 0.2s;
  font-size: 12px;
  :hover {
    color: rgba(255, 255, 255, 0.6);
  }
`;

const AddWriter = styled.div`
  padding: 20px;
  border-radius: 4px;
  flex: 1;
  max-width: 100%;
  min-width: 180px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  border: 2px dashed rgba(255, 255, 255, 0.1);
  transition: background 0.2s;
  :hover {
    background: rgba(255, 255, 255, 0.02);
  }
  @media screen and (max-width: 600px) {
    width: 100%;
    max-width: 100%;
    margin-right: 0;
  }
`;

const SplitInput = styled.div`
  display: flex;
`;

const SplitInputInput = styled(Input)`
  flex: 1;
  border-radius: 2px 0 0 2px;
  border-right: none;
  :focus {
    + div {
      border-color: rgba(255, 255, 255, 0.3);
    }
  }
`;

const SplitInputLabel = styled.div`
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-left: none;
  border-radius: 0 2px 2px 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0px 10px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.5);
  transition: border-color 0.2s;
  cursor: default;
`;

const ErrorMsg = styled.div`
  color: hsl(5, 85%, 75%);
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  margin-top: 20px;
  svg {
    margin-right: 10px;
    min-width: 24px;
  }
  @media screen and (max-width: 600px) {
    margin-bottom: 10px;
  }
`;

const EditShares = (props) => {
  let [writers, setWriters] = useState(props.writers);
  let [addingWriter, setAddingWriter] = useState(false);
  let [error, setError] = useState("");
  let [working, setWorking] = useState(false);
  let [authState] = useGlobal("authState");

  const submit = async () => {
    if (working) return;
    // perform validations
    if (writers.length === 0) return setError("At least one writer required!");
    if (writers.filter((i) => i.controlled).length === 0)
      return setError("At least one controlled writer required!");
    let totalShare =
      Math.round(
        writers.reduce((prev, cur) => prev + Number(cur.share) * 100, 0) * 10
      ) / 1000;
    if (totalShare > 100.001 || totalShare < 99.999)
      return setError(
        `Your writer shares currently total ${totalShare}%, but should total 100%!`
      );
    if (writers.filter((i) => !i.share || Number(i.share) === 0).length > 0)
      return setError("All writers must have nonzero shares!");
    setError("");
    // submit
    setWorking(true);
    const response = await axios.post(
      apiRoot,
      {
        query: `
          mutation editShares($pubAcc: Int!, $id: Int!, $writers: [WriterAssociationInput!]!) {
            publishingAccount(id: $pubAcc) {
              updateShares(workId: $id, shares: $writers)
            }
          }`,
        variables: {
          pubAcc: authState.publishingAccount.id,
          id: props.id,
          writers: writers.map((i) => ({
            writerId: i.id,
            controlled: i.controlled,
            share: Number(i.share),
          })),
        },
      },
      { withCredentials: true }
    );
    if (response.data.errors) {
      setWorking(false);
      return setError(response.data.errors[0].message);
    }
    setWorking(false);
    props.finish(true);
  };

  return (
    <div style={{ maxWidth: "700px" }}>
      {addingWriter && (
        <AddSongwriterModal
          close={() => setAddingWriter(false)}
          writers={writers.map((i) => i.id)}
          addWriter={(writer) =>
            setWriters([
              ...writers,
              { ...writer, share: "", controlled: false },
            ])
          }
        />
      )}
      <WriterContainer>
        {writers.map((i) => (
          <Songwriter key={i.id}>
            <WriterName>
              {i.first_name ? `${i.first_name} ` : ""}
              {i.middle_name ? `${i.middle_name} ` : ""}
              {i.last_name}
              {i.id === authState?.publishingAccount?.songwriter?.id && (
                <You>YOU</You>
              )}
            </WriterName>
            <WriterSociety>
              {i.ipi && i.society
                ? `${i.society} — IPI: ${i.ipi}`
                : "No society affiliation"}
            </WriterSociety>
            <InputGroup>
              <Label>Collection share</Label>
              <SplitInput>
                <SplitInputInput
                  value={i.share}
                  onChange={(e) =>
                    setWriters(
                      writers.map((w) =>
                        w.id === i.id
                          ? { ...w, share: filterShare(e.target.value) }
                          : w
                      )
                    )
                  }
                ></SplitInputInput>
                <SplitInputLabel>%</SplitInputLabel>
              </SplitInput>
            </InputGroup>
            {authState?.publishingAccount?.type !== "songwriter" && (
              <VerticalDivider />
            )}
            {authState?.publishingAccount?.type !== "songwriter" && (
              <Checkbox
                active={i.controlled}
                setActive={(controlled) =>
                  setWriters(
                    writers.map((w) =>
                      w.id === i.id ? { ...w, controlled } : w
                    )
                  )
                }
                small={true}
              >
                Controlled
              </Checkbox>
            )}
            {i.id !== authState?.publishingAccount?.songwriter?.id && (
              <RemoveButton
                onClick={() => setWriters(writers.filter((w) => w.id !== i.id))}
              >
                Remove
              </RemoveButton>
            )}
          </Songwriter>
        ))}
        <AddWriter onClick={() => setAddingWriter(true)}>Add writer</AddWriter>
      </WriterContainer>
      {error ? (
        <ErrorMsg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <path
              fill="hsl(5, 100%, 70%)"
              d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm0 9a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1zm0 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
            />
          </svg>
          {error}
        </ErrorMsg>
      ) : (
        <div />
      )}
      <ButtonContainer>
        <LightButton onClick={() => props.finish(false)}>Cancel</LightButton>
        <Button onClick={submit}>Submit</Button>
      </ButtonContainer>
    </div>
  );
};

export default EditShares;
